import { Admin } from "@/types";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import {
  sanitizeFieldRestProps,
  useGetPathForRecord,
  useRecordContext,
} from "react-admin";
import { useNavigate } from "react-router-dom";
import { AdminNameCellProps } from "./admin-name-cell.types";

const AdminCellName: FC<AdminNameCellProps> = ({ resourceName, ...props }) => {
  const navigate = useNavigate();
  const admin = useRecordContext<Admin>();
  const recordPath = useGetPathForRecord({
    record: admin,
    resource: resourceName,
  });

  const onRowClick = () => {
    navigate(recordPath || "", {
      state: { _scrollToTop: true },
    });
  };

  if (!admin) return null;

  return (
    <Stack
      direction={"row"}
      spacing={2}
      sx={{ cursor: "pointer" }}
      alignItems={"center"}
      onClick={onRowClick}
      {...sanitizeFieldRestProps(props)}
    >
      <Typography component="span" variant="body2" noWrap={true}>
        {admin.fullName || "—"}
      </Typography>
    </Stack>
  );
};

export { AdminCellName };
